import {createStyles, Group} from '@mantine/core';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';
import PlainSearchInput, {ClearType} from 'ui-library/PlainSearchInput';
import {GenericEvent} from 'util/Types';

import {
  ContainerRelevantItemsFilteredTableState,
  ContainerRelevantItemsFilterOption,
  UpdateContainerRelevantItemsFilteredTableState,
} from './ContainerRelevantItemsFilteredTableState';

const useStyles = createStyles((theme) => ({
  header: {
    lineHeight: '24px',
    width: '100%',
    marginLeft: theme.spacing.xs,
  },
}));

export interface ContainerRelevantItemsSectionHeaderProps {
  filteredTableState: ContainerRelevantItemsFilteredTableState;
  updateFilteredTableState: UpdateContainerRelevantItemsFilteredTableState;
}

export default function ContainerRelevantItemsSectionHeader(
  props: ContainerRelevantItemsSectionHeaderProps
): JSX.Element {
  const {classes} = useStyles();
  const {filterOption, searchQuery} = props.filteredTableState;
  const filteredMenuOptions = Object.values(ContainerRelevantItemsFilterOption).filter(
    (option) => option !== ContainerRelevantItemsFilterOption.PROCESSES || BenchlingConfig.WORKFLOWS_ENABLE
  );
  return (
    <div className={classes.header}>
      <Group position="apart" align="center" mb="sm">
        <Group align="center">
          <SelectDropdown
            className="u-display-inline-block"
            displayName={filterOption}
            menu={
              <Menu width={MenuWidth.MEDIUM}>
                {filteredMenuOptions.map((option) => (
                  <Option
                    key={option}
                    onSelect={() => {
                      props.updateFilteredTableState({filterOption: option});
                    }}
                  >
                    {option}
                  </Option>
                ))}
              </Menu>
            }
          />
        </Group>
        <Group align="center" spacing="xs">
          <PlainSearchInput
            clearType={ClearType.X}
            placeholder="Search"
            onChange={(e: GenericEvent) => {
              props.updateFilteredTableState({searchQuery: e.target.value});
            }}
            onEscape={() => {
              props.updateFilteredTableState({searchQuery: ''});
            }}
            value={searchQuery}
          />
        </Group>
      </Group>
    </div>
  );
}
